module.exports = __webpack_public_path__ + "img/faq2_1-md.9578fe98.png";